import { LazyLoadedStates, LazyLoadedStatesManager } from '@edl-development/edl-common';

export const SupervisionManagementLazyLoadedStates = new LazyLoadedStatesManager<{
    base: LazyLoadedStates
    view: LazyLoadedStates
}> ({
    base: {
        name: 'authenticated.supervision-management',
        url: '/supervision-management',
    },
    view: {
        name: 'authenticated.supervision-management.view',
        url: '/view?page&userType&bid&year&searchBy&isSupervisorOnly&isActionNeededOnly&pageSize',
    }
},
() => import('src/app/supervision-management/supervision-management.module').then((result: {SupervisionManagementModule: any}) => result.SupervisionManagementModule)
);
